module.exports = __webpack_public_path__ + "static/media/google-logo.b7727941.svg";